import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "q-mb-lg entry-check-table" };
const _hoisted_2 = { class: "multiline" };
const _hoisted_3 = { class: "q-mb-lg entry-check-table" };
const _hoisted_4 = { colspan: 2 };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { colspan: 2 };
const _hoisted_7 = { colspan: 2 };
const _hoisted_8 = { class: "email-td" };
const _hoisted_9 = { class: "changeUrl" };
const _hoisted_10 = { colspan: 2 };
const _hoisted_11 = {
    key: 0,
    class: "changeUrl"
};
const _hoisted_12 = { key: 1 };
const _hoisted_13 = { class: "q-mb-lg entry-check-table" };
const _hoisted_14 = { colspan: 2 };
const _hoisted_15 = { key: 0 };
const _hoisted_16 = { colspan: 2 };
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { colspan: 2 };
const _hoisted_19 = { colspan: 2 };
const _hoisted_20 = { colspan: 2 };
const _hoisted_21 = { colspan: 2 };
const _hoisted_22 = {
    key: 0,
    class: "changeUrl"
};
const _hoisted_23 = { class: "q-mb-lg entry-check-table" };
const _hoisted_24 = { class: "multiline" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_btn = _resolveComponent("q-btn");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "table-caption" }, "物件情報", -1)),
        _createElementVNode("table", _hoisted_1, [
            _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                    _cache[0] || (_cache[0] = _createElementVNode("th", null, "住所", -1)),
                    _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.nyukyoKeiyaku.addressAll), 1)
                ])
            ])
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "table-caption" }, "お客様情報", -1)),
        _createElementVNode("table", _hoisted_3, [
            _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                    _cache[1] || (_cache[1] = _createElementVNode("th", null, "契約者名", -1)),
                    _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.personal.keiyakusha), 1)
                ]),
                (_ctx.nyukyoKeiyaku.roomSb != 2)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                        _cache[2] || (_cache[2] = _createElementVNode("th", null, "入居者名", -1)),
                        _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.nyukyoKeiyaku.nyukyosha), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                    _cache[3] || (_cache[3] = _createElementVNode("th", null, "連絡先電話番号", -1)),
                    _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.personal.telephoneNumber), 1)
                ]),
                _createElementVNode("tr", null, [
                    _cache[4] || (_cache[4] = _createElementVNode("th", null, "メールアドレス", -1)),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.personal.email), 1),
                    _createElementVNode("td", _hoisted_9, [
                        _createVNode(_component_q_btn, {
                            size: "md",
                            label: "メールアドレス変更",
                            color: "green-7",
                            "icon-right": "navigate_next",
                            to: { name: 'mailaddress-change' }
                        })
                    ])
                ]),
                _createElementVNode("tr", null, [
                    _cache[5] || (_cache[5] = _createElementVNode("th", null, "契約日", -1)),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.nyukyoKeiyaku.keiyakuYmd), 1)
                ])
            ])
        ]),
        (_ctx.personal.canChangePassword)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_q_btn, {
                    size: "md",
                    label: "パスワード変更",
                    color: "green-7",
                    "icon-right": "navigate_next",
                    onClick: _ctx.toPasswordChangePage
                }, null, 8, ["onClick"])
            ]))
            : _createCommentVNode("", true),
        (!_ctx.personal.isMma)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "table-caption" }, "口座情報", -1)),
                _createElementVNode("div", {
                    style: _normalizeStyle(_ctx.$q.screen.lt.md ? 'font-size: 14px;' : '')
                }, _toDisplayString(_ctx.kouzaCaption), 5),
                _createElementVNode("table", _hoisted_13, [
                    _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                            _cache[6] || (_cache[6] = _createElementVNode("th", { rowspan: 2 }, "金融機関", -1)),
                            _createElementVNode("td", _hoisted_14, [
                                _createTextVNode(_toDisplayString(_ctx.personal.bankName), 1),
                                (_ctx.personal.bankName)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "銀行"))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_16, [
                                _createTextVNode(_toDisplayString(_ctx.personal.bansName), 1),
                                (_ctx.personal.bansName)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "支店"))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("tr", null, [
                            _cache[7] || (_cache[7] = _createElementVNode("th", null, "口座種別", -1)),
                            _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.kouzaSbName), 1)
                        ]),
                        _createElementVNode("tr", null, [
                            _cache[8] || (_cache[8] = _createElementVNode("th", null, "口座番号", -1)),
                            _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.maskingKouzaNumber), 1)
                        ]),
                        _createElementVNode("tr", null, [
                            _cache[9] || (_cache[9] = _createElementVNode("th", null, "口座名義", -1)),
                            _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.personal.kouzaName), 1)
                        ]),
                        _createElementVNode("tr", null, [
                            _cache[10] || (_cache[10] = _createElementVNode("th", null, "口座名義（ｶﾅ）", -1)),
                            _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.personal.kouzaKana), 1)
                        ])
                    ])
                ]),
                (_ctx.personal.canChangePassword)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(_component_q_btn, {
                            size: "md",
                            label: "口座情報の変更",
                            color: "green-7",
                            "icon-right": "navigate_next",
                            onClick: _ctx.toEditPage
                        }, null, 8, ["onClick"])
                    ]))
                    : _createCommentVNode("", true)
            ]))
            : _createCommentVNode("", true),
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "table-caption" }, "担当店舗", -1)),
        _createElementVNode("table", _hoisted_23, [
            _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                    _cache[12] || (_cache[12] = _createElementVNode("th", null, "店舗名", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.nyukyoKeiyaku.shopName), 1)
                ]),
                _createElementVNode("tr", null, [
                    _cache[13] || (_cache[13] = _createElementVNode("th", null, "店舗住所", -1)),
                    _createElementVNode("td", _hoisted_24, [
                        _createElementVNode("div", null, "〒" + _toDisplayString(_ctx.nyukyoKeiyaku.shopPostcode), 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.nyukyoKeiyaku.shopAdr1), 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.nyukyoKeiyaku.shopAdr2), 1)
                    ])
                ])
            ])
        ])
    ], 64));
}
